export default "__VITE_ASSET__DpnqkzB___"